
import React, { useEffect, useState } from 'react';
import './spiderman.css'
import FavoriteIcon from '@mui/icons-material/Favorite';
// import logo from '../../assests/images/profile.jpg'

// import { getregister, getregisterfilter , getcaste } from "./../action/user";
import config from "../../lib/config";
import { getmyprofile, userpackagedetail } from "./../action/user";
import ImageTab from '../sidebar/ImageTabSlider';
import ImageGallery from "react-image-gallery";
import ImageSlider from './ImageSlider';
import whyeliteRight from "../../assests/images/whyelite-right.png";
import whyeliteLeft from "../../assests/images/whyelite-left.svg";

function Freesearch() {

    const [showPopup, setShowPopup] = useState(false);

    const [post, setRegister] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [height1, setHeight] = useState(window.innerHeight);
    const [profileimg, setprofileimg] = useState([]);
    const [profileimg1, setprofileimg1] = useState([]);
    // const [registerfilter, setRegisterfilters]=useState([]);
    const [userpackages, setuserpackages] = useState(null);

    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }
    useEffect(() => {

        // console.log(width);

        // console.log(height1);
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    });

    const togglePopup = () => {
        // Depending on the open/close state of the pop up

        setShowPopup(!showPopup);
    };

    const closeModal = (e) => {

        // console.log(e.target.className);
        if (e.target.className === "popup") {
            togglePopup();
        }
    };

    const getUserData = async () => {
        var test = await getmyprofile();

        console.log(test, "Checkkkkkkkkkkkkkkkkkkkkkkkkk");
        setRegister(test.userValue);
        // setprofileimg1(test.userValue.userValue.photopath[0])
        // console.log(test.userValue.userValue.photopath[0], "profileimg1profileimg1profileimg1")
        if (test.userValue.photopath.length && test.userValue.photopath[0]) {
            setprofileimg(test.userValue.photopath.map(url => ({
                original: config.API + `/images/user/${url}`,
                thumbnail: config.API + `/images/user/${url}`,
                originalHeight: "200",
                originalWidth: "200",
                thumbnailHeight: "50",
            })))
        }
        var userdetail = await userpackagedetail();
        setuserpackages(userdetail.userValue);
        // console.log(test, "twinkle");
    }

    function changenumbertojathagam(text) {
        if (text) {
            const tamil_lang = [
                'J',
                'K',
                'L',
                'Mar',
                'Me',
                'Mo',
                'Ra',
                'Sa',
                'Su',
                'Ve',
                'Man',
                'Va'
            ];
            const newarray = text.split("/");
            const final = newarray.map(e => {
                return e = tamil_lang[e - 1];
            });
            //    
            // console.log(final.join("/"), "bdfgfdgdf");
            return final.join("/");
        } else {
            return "";
        }
    }
    useEffect(() => {
        //logout(history)
        getUserData();
    }, []);


    // const getUserData = async () => {
    // //
    // console.log(filterobj,"fghjfghjfgdjhg");post
    // var test = await getregisterfilter();
    // setRegisterfilters(test.userValue);
    //   
    // console.log(test, "win");

    // }
    // useEffect(() => {
    // //logout(history)
    // getUserData();
    // }, []);
    const [isZoomed, setIsZoomed] = useState(false)
    const handleImageClick = () => setIsZoomed(true);
    const closeZoom = () => setIsZoomed(false);

    // Determine image source
    const imgSrc = profileimg.length
        ? config.API + "/images/user/" + post.photopath[0]
        : ("sex" in post && post?.sex === "Male"
            ? require('../../assests/images/man.png')
            : require('../../assests/images/woman.png'));

    const incomeRanges = [
        { value: "0-5", title: "₹0 to ₹5 Lakh yearly" },
        { value: "5-10", title: "₹5 Lakh to ₹10 Lakh yearly" },
        { value: "10-15", title: "₹10 Lakh to ₹15 Lakh yearly" },
        { value: "15-20", title: "₹15 Lakh to ₹20 Lakh yearly" },
        { value: "20-25", title: "₹20 Lakh to ₹25 Lakh yearly" },
        { value: "25-30", title: "₹25 Lakh to ₹30 Lakh yearly" },
        { value: "30-35", title: "₹30 Lakh to ₹35 Lakh yearly" },
        { value: "35-40", title: "₹35 Lakh to ₹40 Lakh yearly" },
        { value: "40-45", title: "₹40 Lakh to ₹45 Lakh yearly" },
        { value: "45-50", title: "₹45 Lakh to ₹50 Lakh yearly" },
        { value: "50-55", title: "₹50 Lakh to ₹55 Lakh yearly" },
        { value: "55-60", title: "₹55 Lakh to ₹60 Lakh yearly" },
        { value: "60-65", title: "₹60 Lakh to ₹65 Lakh yearly" },
        { value: "65-70", title: "₹65 Lakh to ₹70 Lakh yearly" },
        { value: "70-75", title: "₹70 Lakh to ₹75 Lakh yearly" },
        { value: "75-80", title: "₹75 Lakh to ₹80 Lakh yearly" },
        { value: "80-85", title: "₹80 Lakh to ₹85 Lakh yearly" },
        { value: "85-90", title: "₹85 Lakh to ₹90 Lakh yearly" },
        { value: "90-95", title: "₹90 Lakh to ₹95 Lakh yearly" },
        { value: "95-100", title: "₹95 Lakh to ₹1 Cr yearly" },
        { value: "100+", title: "₹1 Cr+ yearly" },
        { value: "prefer-not-to-say", title: "Prefer not to say" }
    ];

    const occupations = [
        { title: "CxO / Chairman / Director / President", value: "CxO / Chairman / Director / President" },
        { title: "VP / AVP / GM / DGM", value: "VP / AVP / GM / DGM" },
        { title: "Sr. Manager / Manager", value: "Sr. Manager / Manager" },
        { title: "Consultant / Supervisor / Team Leads", value: "Consultant / Supervisor / Team Leads" },
        { title: "Team Member / Staff", value: "Team Member / Staff" },

        { title: "Air Hostess / Flight Attendant", value: "Air Hostess / Flight Attendant" },
        { title: "Pilot / Co-Pilot", value: "Pilot / Co-Pilot" },

        { title: "Architect", value: "Architect" },
        { title: "Interior Designer", value: "Interior Designer" },
        { title: "Landscape Architect", value: "Landscape Architect" },

        { title: "Animator", value: "Animator" },
        { title: "Commercial Artist", value: "Commercial Artist" },
        { title: "Web / UX Designers", value: "Web / UX Designers" },

        { title: "Beautician", value: "Beautician" },
        { title: "Fashion Designer", value: "Fashion Designer" },
        { title: "Hairstylist", value: "Hairstylist" },
        { title: "Jewellery Designer", value: "Jewellery Designer" },

        { title: "Customer Support / BPO / KPO Professional", value: "Customer Support / BPO / KPO Professional" },

        { title: "IAS / IRS / IES / IFS", value: "IAS / IRS / IES / IFS" },
        { title: "Indian Police Services [IPS]", value: "Indian Police Services [IPS]" },

        { title: "Airforce", value: "Airforce" },
        { title: "Army", value: "Army" },
        { title: "Navy", value: "Navy" },

        { title: "Lecturer", value: "Lecturer" },
        { title: "Professor", value: "Professor" },
        { title: "Research Assistant", value: "Research Assistant" },
        { title: "Research Scholar", value: "Research Scholar" },
        { title: "Teacher", value: "Teacher" },

        { title: "Civil Engineer", value: "Civil Engineer" },
        { title: "Electronics / Telecom Engineer", value: "Electronics / Telecom Engineer" },
        { title: "Mechanical / Production Engineer", value: "Mechanical / Production Engineer" },

        { title: "Chef / Sommelier / Food Critic", value: "Chef / Sommelier / Food Critic" },
        { title: "Catering Professional", value: "Catering Professional" },

        { title: "Software Developer / Programmer", value: "Software Developer / Programmer" },
        { title: "Software Consultant", value: "Software Consultant" },
        { title: "Hardware & Networking professional", value: "Hardware & Networking professional" },

        { title: "Lawyer", value: "Lawyer" },
        { title: "Legal Assistant", value: "Legal Assistant" },

        { title: "Dentist", value: "Dentist" },
        { title: "Doctor", value: "Doctor" },
        { title: "Medical Transcriptionist", value: "Medical Transcriptionist" },
        { title: "Nurse", value: "Nurse" },
        { title: "Pharmacist", value: "Pharmacist" },
        { title: "Physician Assistant", value: "Physician Assistant" },
        { title: "Physiotherapist / Occupational Therapist", value: "Physiotherapist / Occupational Therapist" },
        { title: "Psychologist", value: "Psychologist" },
        { title: "Surgeon", value: "Surgeon" },
        { title: "Veterinary Doctor", value: "Veterinary Doctor" },

        { title: "Merchant Naval Officer", value: "Merchant Naval Officer" },
        { title: "Mariner", value: "Mariner" },

        { title: "Marketing Professional", value: "Marketing Professional" },
        { title: "Sales Professional", value: "Sales Professional" },

        { title: "Biologist / Botanist", value: "Biologist / Botanist" },
        { title: "Physicist", value: "Physicist" },
        { title: "No Job", value: "No Job" },
        { title: "Others", value: "Others" },
    ];

    const educationOptions = [
        { title: "High School", value: "High School" },
        { title: "Higher Secondary", value: "Higher Secondary" },
        { title: "Diploma", value: "Diploma" },
        { title: "Bachelor's Degree", value: "Bachelor's Degree" },
        { title: "Master's Degree", value: "Master's Degree" },
        { title: "MBA", value: "MBA" },
        { title: "MCA", value: "MCA" },
        { title: "B.Tech", value: "B.Tech" },
        { title: "M.Tech", value: "M.Tech" },
        { title: "MBBS", value: "MBBS" },
        { title: "MD", value: "MD" },
        { title: "PhD", value: "PhD" },
        { title: "CA (Chartered Accountant)", value: "CA" },
        { title: "CS (Company Secretary)", value: "CS" },
        { title: "ICWA", value: "ICWA" },
        { title: "LLB", value: "LLB" },
        { title: "LLM", value: "LLM" },
        { title: "B.Arch", value: "B.Arch" },
        { title: "M.Arch", value: "M.Arch" },
        { title: "B.Sc", value: "B.Sc" },
        { title: "M.Sc", value: "M.Sc" },
        { title: "B.Com", value: "B.Com" },
        { title: "M.Com", value: "M.Com" },
        { title: "BA", value: "BA" },
        { title: "MA", value: "MA" },
        { title: "BBA", value: "BBA" },
        { title: "BCA", value: "BCA" },
        { title: "Others", value: "Others" },
    ];

    const sectors = [
        { title: "Private Sector - IT/Software", value: "Private Sector - IT/Software" },
        { title: "Private Sector - MNC", value: "Private Sector - MNC" },
        { title: "Private Sector - Corporate", value: "Private Sector - Corporate" },
        { title: "Private Sector - Others", value: "Private Sector - Others" },

        { title: "Government - Central Government", value: "Government - Central Government" },
        { title: "Government - State Government", value: "Government - State Government" },
        { title: "Government - PSU (Public Sector Undertaking)", value: "Government - PSU" },
        { title: "Government - Defence", value: "Government - Defence" },
        { title: "Government - Others", value: "Government - Others" },

        { title: "Business / Self-Employed", value: "Business / Self-Employed" },
        { title: "Not Working", value: "Not Working" },
        { title: "Others", value: "Others" },
    ];

    return (

        // <div className="container">


        //     <div className="textCenter" >
        //         {post.membership ? <button className='theri'>{post.membership} Package</button> : null}
        //         <div className="App">
        //             {/* <a href='/edit'> */}
        //             <button className='kuselan' onClick={togglePopup}>Edit Profile</button>
        //             {showPopup ? (
        //                 <div className="popup" onClick={(e) => closeModal(e)}>
        //                     <div className="popup_inner">
        //                         <h2 style={{ color: "black", fontWeight: "bold" }}>You can change your details, contact your admin.</h2>
        //                         <h2 style={{ color: "black", fontWeight: "bold", marginTop: "25px" }}>Call: 99 43 31 53 31 </h2>
        //                         <button className="close" onClick={togglePopup}>
        //                             Close
        //                         </button>
        //                     </div>
        //                 </div>
        //             ) : null}
        //             {/* </a> */}
        //         </div>
        //         <div className='container'>
        //             <div className='row'>
        //                 <p className='valimai'>{post.mname}<span className='spank'> ( {post.userid} )</span></p>

        //             </div>

        //             <div className="row" style={width <= 774 ? { height: 'auto' } : { height: '340px' }}>

        //                 <div className="col-md-12 sm-12 ">


        //                     <div className="row" >
        //                         <div className="col-md-6 col-lg-4" >
        //                             {profileimg.length ?
        //                                 // <ImageGallery items={profileimg} showFullscreenButton={false} />
        //                                 <img className="logo viewphotoz" style={{ marginTop: "15px" }} src={config.API + "/images/user/" + post.photopath[0]} />
        //                                 : <img src={"sex" in post && post.sex == "Male" ? require('../../assests/images/man.png') : require('../../assests/images/woman.png')} style={{ width: '70%' }} />

        //                             }
        //                             {/* <ImageTab/> */}

        //                         </div>

        //                         <div className="col-md-6 col-lg-4 karkka">
        //                             <table className='AnDroid' >

        //                                 <tbody><tr >
        //                                     <td className='billa'>Name</td>
        //                                     <td className='kuruvi' >:</td>
        //                                     <td className='alan' >{post.mname} </td>
        //                                 </tr>
        //                                     <tr>
        //                                         <td className='billa'>Educational Qualification</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.educ}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Marital status</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.maritalname == "Marriage" ? "First marriage" : "Remarriage"}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Subdivision</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.subcaste}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Race</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.castename}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Age </td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.age = new Date().getFullYear() - post.year + "" + "Yrs"}</td>
        //                                     </tr>
        //                                 </tbody></table>
        //                         </div>

        //                         <div className="col-md-6 col-lg-4 karkka">
        //                             <table className="sensay" >
        //                                 <tbody><tr>
        //                                     <td className='billa'>Date of birth</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.date + "/" + post.month + "/" + post.year}</td>
        //                                 </tr>
        //                                     <tr>
        //                                         <td className='billa'>Height</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.height}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Color</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.colorname}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Job/Career</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.occup}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>Salary Income</td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'>{post.income}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa'>District </td>
        //                                         <td className='kuruvi'>:</td>
        //                                         <td className='alan'> {post.city}</td>
        //                                     </tr>
        //                                 </tbody>
        //                             </table>

        //                             {/* <button href="#" className='burg'><b>See photo?</b></button> */}
        //                             {/* <button href="#" className='burg'>Save<FavoriteIcon style={{height:'19px', width:'19px', marginLeft:'5px', marginBottom:'2px'}}/></button> */}
        //                         </div>

        //                     </div>

        //                 </div>
        //             </div>
        //         </div>
        //     </div>



        //     <div className="centerFruit" >
        //         <div className='container'>

        //             <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>

        //                 <div className="col-md-12 sm-12">

        //                     <p className='name1'>Family details</p>

        //                     <div className="row" >

        //                         <div className="col-md-6 ">

        //                             <table className='Boomer' >


        //                                 <tbody><tr>
        //                                     <td className='billa1'>Father's name</td>
        //                                     <td className='kuruvi1'>:</td>
        //                                     <td className='alan1'>{post.father_name}</td>
        //                                 </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Mother's name</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.mother_name}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Father's work</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.dad_work}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Mother's work</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.mom_work}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Brothers (including this one)</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.brother}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Married brothers</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.m_brother}</td>
        //                                     </tr>

        //                                 </tbody></table>
        //                         </div>
        //                         <div className="col-md-6 karkka">
        //                             <table className='Boomer' >
        //                                 <tbody>
        //                                     <tr>
        //                                         <td className='billa1'>Sisters (including this one)</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.sister}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Married sisters</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.m_sister}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Register</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.regis}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Native</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'>{post.puriveaam}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Properties</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.livesity}</td>
        //                                     </tr>
        //                                     <tr>
        //                                         <td className='billa1'>Sear Varusai</td>
        //                                         <td className='kuruvi1'>:</td>
        //                                         <td className='alan1'> {post.ever} </td>
        //                                     </tr>


        //                                 </tbody>
        //                             </table>


        //                         </div>


        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>





















        //     <div className="centerFruit" >

        //         <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //             <div className="col-md-12 sm-12 ">

        //                 <p className='name1'>Address details</p>

        //                 <div className="row" >

        //                     <div className="col-md-12 ">

        //                         <table className='Boomer' >


        //                             <tbody><tr>
        //                                 <td className='billa'>Mobile number</td>
        //                                 <td className='kuruvi'>:</td>
        //                                 <td className='alan'>{post.phone_number}
        //                                     { /* { (localStorage.user_token) ? (<><a href='/myprofile' style={{ color:"white", fontSize:"18px", borderRadius:"6px", backgroundColor:"#b91d97", padding:"7px 9px 12px 9px"}}>My profile</a><a onClick={onlogout} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", padding:"7px 9px 12px 9px"}} marginLeft:"9px", fontWeight:"800"}}><img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"24px"}} src={ require('../../assests/images/logout.png') } /> Logout</a></>) : (<><a href='/registration' style={{ color:"white", fontSize:"18px", borderRadius:"6px"). backgroundColor:"#b91d97", padding:"7px 9px 12px 9px", marginLeft:"8px"}}>Registration</a> <a onClick={handleOpen} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", fontSize:"22px", marginLeft:"9px", fontWeight:"700"}}> <img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"18px"}} src={ require('../../assests/images/person.png') } /> Login</a></>)} */}
        //                                 </td>
        //                             </tr>
        //                                 <tr>
        //                                     <td className='billa'>Address</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.address}</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td className='billa'>Email address</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.email_id}</td>
        //                                 </tr>

        //                             </tbody></table>
        //                     </div>


        //                 </div>
        //             </div>
        //         </div>
        //     </div>

        //     <div className="centerFruit" >

        //         <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
        //             <div className="col-md-12 sm-12 ">

        //                 <p className='name1'>Horoscope details</p>

        //                 <div className="row" >

        //                     <div className="col-md-6 ">

        //                         <table className='Boomer' >


        //                             <tbody><tr>
        //                                 <td className='billa'>Star</td>
        //                                 <td className='kuruvi'>:</td>
        //                                 <td className='alan'>{post.starname}</td>
        //                             </tr>
        //                                 <tr>
        //                                     <td className='billa'>Zodiac sign</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.zodiacname}</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td className='billa'>Ascendant</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.gothra}</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td className='billa'>Directional balance</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.directionname}</td>
        //                                 </tr>


        //                             </tbody></table>
        //                     </div>
        //                     <div className="col-md-6 karkka">
        //                         <table className='Boomer' >
        //                             <tbody>
        //                                 <tr>
        //                                     <td className='billa'>Year</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.s_year}</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td className='billa'>Month</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'> {post.s_month}</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td className='billa'>Day</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.s_day}</td>
        //                                 </tr>
        //                                 <tr>
        //                                     <td className='billa'>Patham</td>
        //                                     <td className='kuruvi'>:</td>
        //                                     <td className='alan'>{post.patham}</td>
        //                                 </tr>
        //                                 {/* <tr>
        //                             <td className='billa'>About Us</td>
        //                             <td className='kuruvi'>:</td>
        //                             <td className='alan'>{post.comment}</td>
        //                         </tr> */}

        //                             </tbody>
        //                         </table>


        //                     </div>


        //                 </div>
        //             </div>
        //         </div>
        //     </div>



        //     <div className style={{ marginTop: '30px' }}>
        //         <img src={require('../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
        //         <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
        //             <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
        //                 <tbody>
        //                     <tr>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r1)}
        //                                 id="r1"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r2)}
        //                                 id="r2"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r3)}
        //                                 id="r3"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r4)}
        //                                 id="r4"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <div></div>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a1)}
        //                                 id="a1"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a2)}
        //                                 id="a2"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a3)}
        //                                 id="a3"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a4)}
        //                                 id="a4"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                     </tr>
        //                     <tr>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r5)}
        //                                 id="r5"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td colspan="2" rowspan="2" width="124" align="center">
        //                             <img src={require('../../assests/images/raaasi_en.png')} width={112} height={45} />
        //                         </td>
        //                         <td><textarea
        //                             value={changenumbertojathagam(post.r6)}
        //                             id="r6"
        //                             readonly
        //                             style={{ textAlign: "center" }}
        //                             minRows={3}
        //                             Cols={8}
        //                             formControlProps={{
        //                                 fullWidth: true,
        //                             }} />
        //                         </td>
        //                         <div></div>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a5)}
        //                                 id="a5"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td rowspan="2" colspan="2" width="133" align="center">
        //                             <img src={require('../../assests/images/amsam_en.png')} width={112} height={45} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a6)}
        //                                 id="a6"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                     </tr>
        //                     <tr>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r7)}
        //                                 id="r7"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r8)}
        //                                 id="r8"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <div></div>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a7)}
        //                                 id="a7"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td width="57" height="63" align="center">
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a8)}
        //                                 id="a8"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                     </tr>
        //                     <tr>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r9)}
        //                                 id="r9"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r10)}
        //                                 id="r10"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r11)}
        //                                 id="r11"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.r12)}
        //                                 id="r12"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <div></div>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a9)}
        //                                 id="a9"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a10)}
        //                                 id="a10"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a11)}
        //                                 id="a11"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                         <td>
        //                             <textarea
        //                                 value={changenumbertojathagam(post.a12)}
        //                                 id="a12"
        //                                 readonly
        //                                 style={{ textAlign: "center" }}
        //                                 minRows={3}
        //                                 Cols={8}
        //                                 formControlProps={{
        //                                     fullWidth: true,
        //                                 }} />
        //                         </td>
        //                     </tr>
        //                 </tbody>
        //             </table>
        //         </div>
        //     </div>





        // </div>
        <div className={`container container-top ${userpackages && userpackages.totalcount > 99 ? "member" : ""}`}>
            <div class="topright-hide" style={{ textAlign: 'left' }}>
                <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
            </div>
            <div className="textCenter" >
                {post.membership ? <button className="theri">{post.membership} Package</button> : null}
            </div>
            <div className="App">
                <button className='kuselan' onClick={togglePopup}>Edit Profile</button>
                {showPopup ? (
                    <div className="popup" onClick={(e) => closeModal(e)}>
                        <div className="popup_inner">
                            <h2 style={{ color: "black", fontWeight: "bold" }}>You can change your details, contact your admin.</h2>
                            <h2 style={{ color: "black", fontWeight: "bold", marginTop: "25px" }}>Call: 96529 66888 </h2>
                            <button className="close" onClick={togglePopup}>
                                Close
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
            <div className="centerFruit container" >
                <div className="row" style={{ marginTop: '70px' }}>
                    <div className="col-12 col-md-8 mb-3">
                        <div className='dark-beige'>
                            <span className='heading'>
                                <strong>PERSONAL INFORMATION</strong>
                            </span>
                        </div>
                        <div className="centerFruit container text-uppercase">
                            <div className="row">
                                <div className="col-12 col-md-8-custom mb-3 border-end">
                                    <table className="AnDroid w-100">
                                        <tbody>
                                            <tr>
                                                <td className="billa">Name</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.mname}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Age</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{new Date().getFullYear() - post.year} Yrs</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Gender</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.sex}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Marital Status</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.maritalname === "Marriage" ? "First marriage" : "Remarriage"}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Caste</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.castename}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Sub Caste</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.subcaste}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Place of Residence</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.place_of_residence}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Place of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.place_of_birth}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Date of Birth</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.date + "/" + post.month + "/" + post.year}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Height</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.height}</td>
                                            </tr>
                                            <tr>
                                                <td className="billa">Color</td>
                                                <td className="kuruvi">:</td>
                                                <td className="alan">{post.colorname}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4" style={{ alignContent: 'center' }}>
                        <ImageSlider post={post} config={config} />
                    </div>
                </div>
            </div>


            <div className='dark-beige'>
                <span className='heading'>
                    <strong>EDUCATION/WORK EXPERIENCE</strong>
                </span>
            </div>
            <div className="centerFruit container text-uppercase">
                <div className="row">
                    <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100 border-end">
                            <tbody>
                                <tr>
                                    <td className="billa">Job/Career</td>
                                    <td className="kuruvi">:</td>
                                    {/* <td className="alan">{post.occup && (occupations.some(item => item.title === post?.occup) ? post?.occup : post?.occup + " (Others)")}</td> */}
                                    <td className="alan">{post.occup}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Salary Income</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{incomeRanges.find(item => item.value === post?.income)?.title || ""}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100 border-end">
                            <tbody>
                                <tr>
                                    <td className="billa">Work Sector</td>
                                    <td className="kuruvi">:</td>
                                    {/* <td className="alan">{post.work_sector && (sectors.some(item => item.title === post?.work_sector) ? post?.work_sector : post?.work_sector + " (Others)")}</td> */}
                                    <td className="alan">{post.work_sector}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Company Name</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.company_name}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <table className="AnDroid w-100 border-end">
                            <tbody>
                                <tr>
                                    <td className="billa">Educational Qualification</td>
                                    <td className="kuruvi">:</td>
                                    {/* <td className="alan">{post.educ && (educationOptions.some(item => item.title === post?.educ) ? post?.educ : post?.educ + " (Others)")}</td> */}
                                    <td className="alan">{post.educ}</td>
                                </tr>
                                <tr>
                                    <td className="billa">Higher Educational Qualification</td>
                                    <td className="kuruvi">:</td>
                                    <td className="alan">{post.higher_education_qualification}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>FAMILY INFORMATION</strong>
                </span>
            </div>
            <div className="centerFruit container text-uppercase">
                <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                    <div className="col-md-12 sm-12">
                        <div className="row">

                            {/* Column 1 */}
                            <div className="col-12 col-md-4 mb-3 border-end">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Father's Name</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.father_name}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Mother's Name</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.mother_name}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Father's Work</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.dad_work}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Mother's Work</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.mom_work}</td>
                                        </tr>
                                        {/* <tr>
                                            <td className="billa">Community</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.castename}</td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>

                            {/* Column 2 */}
                            <div className="col-12 col-md-4 mb-3 border-end">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Brothers</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.brother}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Married Brothers</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.m_brother}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Sisters</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.sister}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Married Sisters</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.m_sister}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Column 3 */}
                            <div className="col-12 col-md-4 mb-3">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Register</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.regis}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Native</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.puriveaam}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Assets</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.livesity}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Dowry</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.ever}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>CONTACT INFORMATION</strong>
                </span>
            </div>
            <div className="centerFruit container text-uppercase" >
                <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                    <div className="col-md-12 sm-12 ">
                        <div className="row" >
                            <div className="col-md-12 ">
                                <table className='Boomer' >
                                    <tbody>
                                        <tr>
                                            <td className='billa'>Mobile number</td>
                                            <td className='kuruvi'>:</td>
                                            <td className='alan'>{post.phone_number}
                                                { /* { (localStorage.user_token) ? (<><a href='/myprofile' style={{ color:"white", fontSize:"18px", borderRadius:"6px", backgroundColor:"#b91d97", padding:"7px 9px 12px 9px"}}>My profile</a><a onClick={onlogout} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", padding:"7px 9px 12px 9px"}} marginLeft:"9px", fontWeight:"800"}}><img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"24px"}} src={ require('../../assests/images/logout.png') } /> Logout</a></>) : (<><a href='/registration' style={{ color:"white", fontSize:"18px", borderRadius:"6px"). backgroundColor:"#b91d97", padding:"7px 9px 12px 9px", marginLeft:"8px"}}>Registration</a> <a onClick={handleOpen} style={{textTransform:'none', cursor:"pointer", color:"#b91d97", fontSize:"22px", marginLeft:"9px", fontWeight:"700"}}> <img style={{ marginTop:"-7px", marginLeft:"8px", maxWidth:"18px"}} src={ require('../../assests/images/person.png') } /> Login</a></>)} */}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='billa'>City</td>
                                            <td className='kuruvi'>:</td>
                                            <td className='alan'>{post.city}</td>
                                        </tr>
                                        <tr>
                                            <td className='billa'>Address</td>
                                            <td className='kuruvi'>:</td>
                                            <td className='alan'>{post.address}</td>
                                        </tr>
                                        <tr>
                                            <td className='billa'>Place of residence</td>
                                            <td className='kuruvi'>:</td>
                                            <td className='alan'>{post.place_of_residence}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='dark-beige'>
                <span className='heading'>
                    <strong>HOROSCOPE INFORMATION</strong>
                </span>
            </div>
            <div className="centerFruit container text-uppercase">
                <div className="row" style={width <= 774 ? { height: 'auto' } : { height: 'auto' }}>
                    <div className="col-md-12 sm-12">
                        <div className="row">
                            {/* Column 1 */}
                            <div className="col-12 col-md-6 border-end mb-3">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Religion</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.religion}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Star</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.starname}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Zodiac sign</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.zodiacname}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Gothra</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.gothra}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Direction</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.directionname}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Column 2 */}
                            <div className="col-12 col-md-6 mb-3">
                                <table className="Boomer w-100">
                                    <tbody>
                                        <tr>
                                            <td className="billa">Dhosam</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.dhosam}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Patham</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.patham}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Time of Birth</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.time_of_birth}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Year</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.s_year}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Month</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.s_month}</td>
                                        </tr>
                                        <tr>
                                            <td className="billa">Day</td>
                                            <td className="kuruvi">:</td>
                                            <td className="alan">{post.s_day}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="topright-hide" style={{ textAlign: 'right' }}>
                            <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow"
                                style={{ width: '10%', marginTop: '-130px', marginRight: '-22px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className='dark-beige'>
                <span className='heading'>
                    <strong>PHOTOS</strong>
                </span>
            </div>
            <div className="centerFruit container">
                <div className="flex-item" style={{ textAlign: 'center' }}>
                    {profileimg.length ? (
                        post.photopath.map((img, index) => (
                            <img
                                key={index}
                                src={config.API + "/images/user/" + img}
                                alt={`Profile ${index + 1}`}
                                style={{
                                    float: "left",
                                    margin: "10px",
                                    width: "200px",
                                    height: "200px",
                                    objectFit: "fit",
                                }}
                            />
                        ))
                    ) : (
                        <img
                            src={
                                "sex" in post && post.sex === "Male"
                                    ? require('../../assests/images/man.png')
                                    : require('../../assests/images/woman.png')
                            }
                            style={{ width: '70%' }}
                            alt="Default"
                        />
                    )}
                </div>
            </div> */}


            <div className style={{ marginTop: '0px' }}>
                <img src={require('../../assests/images/chat_new_en.png')} className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto' }} />
                <div className="form-group table-responsive" style={{ fontSize: "17px" }}>
                    <table className="rassi-table" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '50px' }}>
                        <tbody>
                            <tr>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r1)}
                                        id="r1"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r2)}
                                        id="r2"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r3)}
                                        id="r3"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r4)}
                                        id="r4"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <div></div>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a1)}
                                        id="a1"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a2)}
                                        id="a2"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a3)}
                                        id="a3"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a4)}
                                        id="a4"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r5)}
                                        id="r5"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td colspan="2" rowspan="2" width="124" align="center">
                                    <img src={require('../../assests/images/raaasi_en.png')} width={112} height={45} />
                                </td>
                                <td><textarea
                                    value={changenumbertojathagam(post.r6)}
                                    id="r6"
                                    readonly
                                    style={{ textAlign: "center" }}
                                    minRows={3}
                                    Cols={8}
                                    formControlProps={{
                                        fullWidth: true,
                                    }} />
                                </td>
                                <div></div>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a5)}
                                        id="a5"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td rowspan="2" colspan="2" width="133" align="center">
                                    <img src={require('../../assests/images/amsam_en.png')} width={112} height={45} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a6)}
                                        id="a6"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r7)}
                                        id="r7"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r8)}
                                        id="r8"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <div style={{ margin: '30px' }}></div>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a7)}
                                        id="a7"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td width="57" height="63" align="center">
                                    <textarea
                                        value={changenumbertojathagam(post.a8)}
                                        id="a8"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r9)}
                                        id="r9"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r10)}
                                        id="r10"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r11)}
                                        id="r11"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.r12)}
                                        id="r12"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <div></div>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a9)}
                                        id="a9"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a10)}
                                        id="a10"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a11)}
                                        id="a11"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                                <td>
                                    <textarea
                                        value={changenumbertojathagam(post.a12)}
                                        id="a12"
                                        readonly
                                        style={{ textAlign: "center" }}
                                        minRows={3}
                                        Cols={8}
                                        formControlProps={{
                                            fullWidth: true,
                                        }} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {post.jathagampic?.length > 0 && (
                    <img src={config.API + "/images/user/" + post.jathagampic} alt="Jathagam" className="img-responsive" style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: "20px" }} />
                )}
            </div>
            <style jsx>
                {`
                @media (max-width: 425px) {
                    .container-top{
                        margin-top: 60px  !important;
                    }
                }`}
            </style>
        </div>
    )
}

export default Freesearch;
